<ng-template #vidDialog>
  <div class="cg-dialog">
    <cigna-icon
      (click)="closeDialog()"
      type="close-thin"
      class="cg-dialog__close_new cg-color-digital-blue"
    ></cigna-icon>

    <h3 class="cg-dialog__header cg-dialog__header--modal">
      {{ titleText }}
    </h3>
    <div class="">
      <section id="dialog-body-content" class="cg-margin-top-sm">
        <div class="cg-spinner"></div>
      </section>
    </div>
  </div>
</ng-template>
